'use strict';
const angular = require('angular');

/*@ngInject*/
export function mapService() {
	
  //Get list of map layers
  this.getMapLayers = function () {
    return [{
      'source': 'tpaLayerSource',
      'type': 'mapbox',
      'name': 'tpaLayer',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckm6px6vtc03717o0j1xjrwc5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'urbanLayerSource',
      'type': 'mapbox',
      'name': 'urbanLayer',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjukbyho05x11art2x1str4h/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'fireRiskLayerSource',
      'type': 'mapbox',
      'name': 'fireRiskLayer',
      'full_name': 'Fire Responsibility Areas and Wildfire Risk (2007)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjui7hfy03w719qucbydh9y5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'seaLevelRise77LayerSource',
      'type': 'mapbox',
      'name': 'seaLevelRise77Layer',
      'full_name': 'BCDC Sea Level Rise - 77 Inch Sea Level Rise Scenario',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjujnnlo05b41amo0l7njch4/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'seaLevelRise36LayerSource',
      'type': 'mapbox',
      'name': 'seaLevelRise36Layer',
      'full_name': 'BCDC Sea Level Rise - 36 Inch Sea Level Rise Scenario',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjujkq5t03n719vv2l3u3fbh/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'liquefactionLayerSource',
      'type': 'mapbox',
      'name': 'liquefactionLayer',
      'full_name': 'Liquefaction Susceptibility (2006)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjuj8zh104sz1alekhiwiiyo/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'earthquakeLayerSource',
      'type': 'mapbox',
      'name': 'earthquakeLayer',
      'full_name': 'Alquist-Priolo Fault Zones (2019)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjujck6u04vy1alezfd73deo/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'floodplainLayerSource',
      'type': 'mapbox',
      'name': 'floodplainLayer',
      'full_name': 'Flood Zones (2020)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjukxff106h719ta36ulg71p/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'landslideLayerSource',
      'type': 'mapbox',
      'name': 'landslideLayer',
      'full_name': 'Existing Landslide Areas (1998)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjuij5a2045y19s3qetvxx49/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'riparianLayerSource',
      'type': 'mapbox',
      'name': 'riparianLayer',
      'full_name': 'Riparian Areas--The Natural Communities Commonly Associated with Groundwater',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjumo3bt087n19qz702x4d6f/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'wildlifeLayerSource',
      'type': 'mapbox',
      'name': 'wildlifeLayer',
      'full_name': 'Critical Habitat (2020)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjvvwe2h08i21amom6q1c0wu/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'sphereofinfluenceLayerSource',
      'type': 'mapbox',
      'name': 'sphereofinfluenceLayer',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckuokp0n7gbob17l7250180iw/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'hcdtcacLayerSource',
      'type': 'mapbox',
      'name': 'hcdtcacLayer',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjukod8004rs19pjcv12g62p/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'cpadLayerSource',
      'type': 'mapbox',
      'name': 'cpadLayer',
      'full_name': 'California Protected Area Database (2020)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckjvuu75606d419peichzdfkt/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'ggLayerSource',
      'type': 'mapbox',
      'name': 'ggLayer',
      'full_name': 'Plan Bay Area 2050 Growth Geographies',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckm6pr3cr04uu17k4fw9ktaf0/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'ppaLayerSource',
      'type': 'mapbox',
      'name': 'ppaLayer',
      'full_name': 'Priority Production Areas',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckr57ass815lt17podifl01a7/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'tcacLayerSource',
      'type': 'mapbox',
      'name': 'tcacLayer',
      'full_name': 'HCD/TCAC Opportunity Areas (2020)',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckr57l1bu15w817r99jpsk1qw/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'znLayerSource',
      'type': 'mapbox',
      'name': 'znLayer',
      'full_name': 'Regional Zoning 2021',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/cktes74h72lvv17qtabrf91il/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'gpLayerSource',
      'type': 'mapbox',
      'name': 'gpLayer',
      'full_name': 'Regional General Plan 2021',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckter6p98114i18oc0ieswft5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'pdaLayerSource',
      'type': 'mapbox',
      'name': 'pdaLayer',
      'url': 'https://api.mapbox.com/styles/v1/mtc-basis/ckuecztk019tp17kvam3ztny5/?access_token=pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNraXo0bGxsZzAzd3Myc3BoZmY5NGZxejkifQ.ZhEM7uybnZJYlQSkyf6oeg'
    }, {
      'source': 'poshLayerSource',
      'type': 'socrata',
      'name': 'poshLayer',
      'url': 'https://data.bayareametro.gov/resource/87zs-ng2p.geojson?$select=shape,affrdunits&$limit=10000',
      'style':'circle',
      'property':'affrdunits',
      'paint': {
        'circle-color': '#dd502c',
        'circle-stroke-width': 1,
        'circle-stroke-color': '#dd502c',
        'circle-opacity': 0.5,
        "circle-radius": {
          property: 'affrdunits',
          stops: [
            [75, 5],
            [150, 10],
            [250, 20],
          ]
        }
      }
    }, {
      'source': 'phLayerSource',
      'type': 'socrata',
      'name': 'phLayer',
      'url': 'https://data.bayareametro.gov/resource/3bj7-zyaq.geojson?$select=shape,total_units&$limit=10000',
      'style':'circle',
      'property':'total_units',
      'paint': {
        'circle-color': '#dd502c',
        'circle-stroke-width': 1,
        'circle-stroke-color': '#dd502c',
        'circle-opacity': 0.5,
        "circle-radius": {
          property: 'total_units',
          stops: [
            [2, 5],
            [5, 10],
            [10, 20],
          ]
        }
      }
    }, {
      'source': 'hcvLayerSource',
      'type': 'socrata',
      'name': 'hcvLayer',
      'url': 'https://data.bayareametro.gov/resource/m8gt-nc4r.json?$select=tract_geoid,hcv_pct&$limit=10000',
      'style':'numerical',
      'property':'hcv_pct',
      'paint': {
        'fill-color': {
          property: 'hcv_pct',
          stops: [
            [5, '#ffffcc'],
            [10, '#a1dab4'],
            [40, '#41b6c4'],
            [70, '#2c7fb8'],
            [100, '#253494']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      }
    }, {
      'source': 'disabilityStatusLayerSource',
      'type': 'socrata',
      'name': 'disabilityStatusLayer',
      'url': 'https://data.bayareametro.gov/resource/bxi4-cbn7.json?$select=tract_geoid,tpop_wdp*100&$limit=10000',
      'style':'numerical',
      'property':'tpop_wdp_100',
      'paint': {
        'fill-color': {
          property: 'tpop_wdp_100',
          stops: [
            [5, '#ffffcc'],
            [10, '#a1dab4'],
            [20, '#41b6c4'],
            [40, '#2c7fb8'],
            [80, '#253494']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      },
    }, {
      'source': 'householdIncomeLayerSource',
      'type': 'socrata',
      'name': 'householdIncomeLayer',
      'url': 'https://data.bayareametro.gov/resource/q89j-amyf.json?$select=tract_geoid,med_inc&$limit=100000',
      'style':'numerical',
      'property':'med_inc',
      'paint': {
        'fill-color': {
          property: 'med_inc',
          stops: [
            [25000, '#ffffcc'],
            [83000, '#a1dab4'],
            [167000, '#41b6c4'],
            [250001, '#225ea8']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      },
     }, {
      'source': 'raceEthnicityLayerSource',
      'type': 'socrata',
      'name': 'raceEthnicityLayer',
      'url': 'https://data.bayareametro.gov/resource/bty8-8dei.json?$select=blkgp_geoid,pred_race&$limit=100000',
      'style':'categorical',
      'property':'pred_race',
      'paint': {
        'fill-color': {
          'property': 'pred_race',
          'type':'categorical',
          'stops': [
            ['Hispanic/Latinx','#e41a1c'],
            ['Non-Hispanic Asian or Pacific Islander','#377eb8'],
            ['Non-Hispanic Black','#4daf4a'],
            ['Non-Hispanic Other','#ff7f00'],
            ['Non-Hispanic White','#f0d6a8'],
            ['Missing or Insufficient Data','#adaba6']
          ],
        'default':'white',
        },
        'fill-opacity': 0.5
      },
      
    }, {
      'source': 'sphLayerSource',
      'type': 'socrata',
      'name': 'sphLayer',
      'url': 'https://data.bayareametro.gov/resource/d3uu-dvsm.json?$select=tract_geoid,nfam_singp*100&$limit=10000',
      'style':'numerical',
      'property':'nfam_singp_100',
      'paint': {
        'fill-color': {
          property: 'nfam_singp_100',
          stops: [
            [10, '#ffffcc'],
            [30, '#a1dab4'],
            [50, '#41b6c4'],
            [80, '#2c7fb8'],
            [100, '#253494']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      },
    }, {
      'source': 'hwcLayerSource',
      'type': 'socrata',
      'name': 'hwcLayer',
      'url': 'https://data.bayareametro.gov/resource/sw8g-na7z.json?$select=tract_geoid,hh_wc_p*100&$limit=10000',
      'style':'numerical',
      'property':'hh_wc_p_100',
      'paint': {
        'fill-color': {
          property: 'hh_wc_p_100',
          stops: [
            [5, '#ffffcc'],
            [10, '#a1dab4'],
            [20, '#41b6c4'],
            [40, '#2c7fb8'],
            [80, '#253494']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      },
    }, {
      'source': 'recapLayerSource',
      'type': 'socrata',
      'name': 'recapLayer',
      'url': 'https://data.bayareametro.gov/resource/tsz4-2bqi.json?rcap_current=1&$select=tract_geoid,rcap_current&$limit=2000',
      'style':'single',
      'paint': {
        'fill-color':	"#1b9e77", // blue color fill
        'fill-opacity': 0.5
        }
    }, {
      'source': 'rcaaLayerSource',
      'type': 'socrata',
      'name': 'rcaaLayer',
      'url': 'https://data.bayareametro.gov/resource/q89j-amyf.json?rcaa=1&$select=tract_geoid,rcaa',
      'style':'single',
      'paint': {
        'fill-color': '#1b9e77', // blue color fill
        'fill-opacity': 0.5
        }
    }, {
      'source': 'hcdaffhtcacLayerSource',
      'type': 'socrata',
      'name': 'hcdaffhtcacLayer',
      'url': 'https://data.bayareametro.gov/resource/vr7h-smni.geojson?$limit=20000&$select=oppcat,geometry',
      'style':'categorical',
      'property':'oppcat',
      'paint': {
        'fill-color': {
          'property': 'oppcat',
          'type':'categorical',
          'stops': [
            ['Highest Resource','#253494'],
            ['High Resource','#2c7fb8'],
            ['Moderate Resource','#41b6c4'],
            ['Low Resource','#a1dab4'],
            ['High Segregation & Poverty','#ffffcc'],
            ['Missing or Insufficient Data','#adaba6'],
          ],
        'default':'white',
        },
        'fill-opacity': 0.5
      }
    }, {
      'source': 'cbhLayerSource',
      'type': 'socrata',
      'name': 'cbhLayer',
      'url': 'https://data.bayareametro.gov/resource/m8gt-nc4r.json?$select=tract_geoid,hcv_pct&$limit=10000',
      'style':'numerical',
      'property':'hcv_pct',
      'paint': {
        'fill-color': {
          property: 'hcv_pct',
          stops: [
            [5, '#ffffcc'],
            [10, '#a1dab4'],
            [40, '#41b6c4'],
            [70, '#2c7fb8'],
            [100, '#253494']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      }
    },{
      'source': 'dispriskLayerSource',
      'type': 'socrata',
      'name': 'dispriskLayer',
      'url': 'https://data.bayareametro.gov/resource/juq7-jgnr.json?$select=tract_geoid,typology&$limit=10000',
      'style':'categorical',
      'property':'typology',
      'paint': {
        'fill-color': {
          'property': 'typology',
          'type':'categorical',
          'stops': [
            ["Low-Income/Susceptible to Displacement", "#87CEFA"],
            ["Ongoing Displacement", "#6495ED"],
            ['At Risk of Gentrification', '#9E9AC8'],
            ["Early/Ongoing Gentrification", "#756BB1"],
            ['Advanced Gentrification', '#54278F'],
            ["Stable Moderate/Mixed Income", "#FBEDE0"],
            ['At Risk of Becoming Exclusive', '#F4C08D'],
            ["Becoming Exclusive", "#EE924F"],
            ["Stable/Advanced Exclusive", "#C95123"],
            ["High Student Population", "#B5B6B7"],
            ["Unavailable or Unreliable Data", "#DEDCD9"]
        ],
        'default':'white',
        },
        'fill-opacity': 0.5
      }
    }, {
      'source': 'ochLayerSource',
      'type': 'socrata',
      'name': 'ochLayer',
      'url': 'https://data.bayareametro.gov/resource/cq4u-4hkv.json?$select=tract_geoid,rrm_gt15p&$limit=10000',
      'style':'numerical',
      'property':'rrm_gt15p',
      'paint': {
        'fill-color': {
          property: 'rrm_gt15p',
          stops:  [
            [5, '#ffffcc'],
            [10, '#a1dab4'],
            [20, '#41b6c4'],
            [40, '#2c7fb8'],
            [80, '#253494']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      }
    }, {
      'source': 'subhouseLayerSource',
      'type': 'socrata',
      'name': 'subhouseLayer',
      'url': 'https://data.bayareametro.gov/resource/8myp-xcdf.json?$select=tract_geoid,pren_ncomp*1000&$limit=10000',
      'style':'numerical',
      'property':'pren_ncomp_1000',
      'paint': {
        'fill-color': {
          property: 'pren_ncomp_1000',
          stops: [
            [5, '#ffffcc'],
            [10, '#a1dab4'],
            [15, '#41b6c4'],
            [20, '#2c7fb8'],
            [30, '#253494']
          ],
          'default':'white',
        },
        'fill-opacity': 0.5
      }
    }];
  }


}

export default angular.module('appApp.mapService', [])
  .service('mapService', mapService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/map/map.service.js